export const EyeOpenIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3866 7.99995C10.3866 9.31995 9.31995 10.3866 7.99995 10.3866C6.67995 10.3866 5.61328 9.31995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C9.31995 5.61328 10.3866 6.67995 10.3866 7.99995Z"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99991 13.5133C10.3532 13.5133 12.5466 12.1267 14.0732 9.72666C14.6732 8.78666 14.6732 7.20665 14.0732 6.26665C12.5466 3.86665 10.3532 2.47998 7.99991 2.47998C5.64657 2.47998 3.45323 3.86665 1.92656 6.26665C1.32656 7.20665 1.32656 8.78666 1.92656 9.72666C3.45323 12.1267 5.64657 13.5133 7.99991 13.5133Z"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
